/* global $ */
import { loadImage } from '../../plugins/lazyload'

function jsSlider () {
    const jsSlider = {
        sliderClass: 'js-slider',
        slideClass: 'js-slider__slide',
        controlsClass: 'js-slider__controls-full-width',
        controlClass: 'js-slider__control',
        playControlClass: 'js-slider__play',
        playIconClass: 'icon icon__play',
        pauseControlClass: 'js-slider__pause',
        pauseIconClass: 'icon icon__pause',
        slider: null,
        sliderAnimTypeAttributeName: 'data-js-slider-animation-type',
        sliderAnimType: 'fade', // valid values are : 'fade', 'directional'
        sliderAnimClasses: { left: 'fade', right: 'fade' },
        slides: null,
        slidesCount: 0,
        sliderTimeout: null,
        revealTimeout: null,
        hideTimeout: null,
        hideTimeout2: null,
        rebindControlsTimeout: null,
        animTime: 1000, // must be >= to css transition time
        sliderAutoSpeed: 5000,
        currentActiveIndex: 0,

        init: function () {
            this.slider = document.querySelector('.' + this.sliderClass)

            if (!this.validSlider()) {
                return
            }

            this.slides = this.slider.querySelectorAll('.' + this.slideClass)
            this.slidesCount = this.slides.length

            if (this.slidesCount >= 2) {
                this.setAnimStyle()
                this.setSlides()
                this.preloadImages()
                this.setSlidesHeight()
                this.bindSliderListeners()
                this.createControls()
                this.bindResize()
                this.startAutoSlide(this.sliderAutoSpeed)
            }
        },

        validSlider: function () {
            if (this.slider == null || typeof this.slider === 'undefined') {
                return false
            } else {
                return true
            }
        },

        bindSliderListeners: function () {
            const self = this

            // When the focus enters the slider, suspend the animation
            this.slider.addEventListener('focusin', function () {
                self.stopAutoSlide()
            })
        },

        setSlides: function () {
            $(this.slides).attr('aria-hidden', true)
            this.slides[0].classList.add('active')
            this.slides[0].setAttribute('aria-hidden', false)
            this.currentActiveIndex = 0
        },

        setSlidesHeight: function () {
            // get highest slide and set this height to all slides

            let highest = 0
            let slideHeight = 0

            for (let i = 0; i < this.slidesCount; i++) {
                // reset to auto to get raw height value

                $(this.slides[i]).height('auto')
                slideHeight = $(this.slides[i]).height()
                highest = slideHeight < highest ? highest : slideHeight
            }
            $(this.slides).height(highest + 'px')
        },

        bindResize: function () {
            // must set slides height at resize

            window.addEventListener('resize', function () {
                jsSlider.setSlidesHeight()
            })
        },

        setAnimStyle: function () {
            const sliderAnimValue = this.slider.getAttribute(this.sliderAnimTypeAttributeName)

            if (sliderAnimValue == null || sliderAnimValue === 'fade') {
                return
            }

            if (sliderAnimValue === 'directional') {
                this.sliderAnimType = 'directional'
                this.sliderAnimClasses.left = 'left'
                this.sliderAnimClasses.right = 'right'
            }
        },

        createControls: function () {
            // create elements
            const controlsContainer = document.createElement('fieldset')
            const playControl = document.createElement('button')
            const playIcon = document.createElement('span')
            const pauseControl = document.createElement('button')
            const pauseIcon = document.createElement('span')

            // fieldset container
            controlsContainer.setAttribute('class', this.controlsClass)
            controlsContainer.setAttribute('aria-controls', 'carousel')
            controlsContainer.setAttribute('aria-label', 'Contrôles du carrousel')

            // play button
            playControl.setAttribute('class', this.playControlClass)
            playControl.setAttribute('aria-label', 'Activer le défilement automatique du carrousel')
            playIcon.setAttribute('class', this.playIconClass)
            playIcon.setAttribute('aria-hidden', 'true')
            playControl.appendChild(playIcon)
            controlsContainer.appendChild(playControl)

            // pause button
            pauseControl.setAttribute('class', this.pauseControlClass)
            pauseControl.setAttribute('aria-label', 'Désactiver le défilement automatique du carrousel')
            pauseIcon.setAttribute('class', this.pauseIconClass)
            pauseIcon.setAttribute('aria-hidden', 'true')
            pauseControl.appendChild(pauseIcon)
            controlsContainer.appendChild(pauseControl)

            // direct slide access buttons
            for (let i = 0; i < this.slidesCount; i++) {
                const newControl = document.createElement('button')
                newControl.setAttribute('class', this.controlClass)
                newControl.setAttribute('data-index', i)
                newControl.setAttribute('aria-label', 'Diapositive ' + (i + 1) + ' de ' + this.slidesCount)
                controlsContainer.appendChild(newControl)
            }

            // append all controls to slider
            this.slider.appendChild(controlsContainer)

            this.bindPlayPause()
            this.bindControls()
            this.updateControls()
        },

        bindPlayPause: function () {
            const self = this

            // bind play control
            $('.' + this.playControlClass).on('click', function () {
                self.stopAutoSlide()
                self.startAutoSlide(500)
            })

            // bind pause control
            $('.' + this.pauseControlClass).on('click', function () {
                self.stopAutoSlide()
            })
        },

        bindControls: function () {
            const self = this

            // bind direct slide access controls
            $('.' + this.controlClass).on('click', function () {
                const newIndex = parseInt(this.getAttribute('data-index'))
                let direction = ''

                // do nothing if click on current index
                if (newIndex === self.currentActiveIndex) {
                    return
                }

                // stop autoslide
                self.stopAutoSlide()

                // unbind controls temporarily
                self.unbindControls()

                // determine direction
                direction = newIndex > self.currentActiveIndex ? self.sliderAnimClasses.right : self.sliderAnimClasses.left

                self.hideSlide(self.currentActiveIndex, direction)
                self.revealSlide(newIndex, direction)
                self.currentActiveIndex = newIndex
                self.updateControls()
                self.updateAriaAttributes()
                self.updateFocus()
            })
        },

        unbindControls: function () {
            // unbind controls when slider is in transition to prevent 2 animation from occuring at same time
            const self = this

            $('.' + this.controlClass).off('click')

            // rebind controls after transition is over
            this.rebindControlsTimeout = setTimeout(function () {
                self.bindControls()
            }, this.animTime)
        },

        updateControls: function () {
            // visually update controls style
            const controlClass = this.controlClass
            const index = this.currentActiveIndex
            const newActiveControl = this.slider.querySelector('.' + controlClass + '[data-index="' + index + '"]')
            $('.' + controlClass).removeClass('active')
            newActiveControl.classList.add('active')
        },

        updateAriaAttributes: function () {
            // update all slides aria-hidden attributes
            $(this.slides).attr('aria-hidden', true)
            this.slides[this.currentActiveIndex].setAttribute('aria-hidden', false)
        },

        updateFocus: function () {
            // set focus on slide content (this function is intended to be called after using a slider control)
            const target = this.slides[this.currentActiveIndex]
            target.setAttribute('tabindex', '-1')
            target.focus()
        },

        revealSlide: function (index, direction) {
            const self = this

            // prepare elem for animation
            this.slides[index].classList.add('fadein')
            this.slides[index].classList.add(direction)
            const image = this.slides[index].querySelector('.lazy-slide')
            if (image !== undefined && image !== null) {
                loadImage(image)
            }

            // quick delay to prevent display:block canceling animation
            self.revealTimeout = setTimeout(function () {
                // add class that launch animation
                self.slides[index].classList.add('active')

                // remove preparation classes
                self.slides[index].classList.remove('fadein')
                self.slides[index].classList.remove(direction)
            }, 45)
        },

        hideSlide: function (index, direction) {
            const self = this

            // must always add and remove 'active' classes at the same time
            this.hideTimeout = setTimeout(function () {
                // the classes that launch animation
                self.slides[index].classList.add('fadeout')
                self.slides[index].classList.add(direction)
                self.slides[index].classList.remove('active')
            }, 50)

            // remove when animation is over
            this.hideTimeout2 = setTimeout(function () {
                self.slides[index].classList.remove('fadeout')
                self.slides[index].classList.remove(direction)
            }, self.animTime)
        },

        startAutoSlide: function (speed) {
            const self = this
            this.sliderTimeout = setTimeout(function () {
                // unbind controls temporarily
                self.unbindControls()

                const newIndex = self.currentActiveIndex === self.slidesCount - 1 ? 0 : parseInt(self.currentActiveIndex) + 1
                self.hideSlide(self.currentActiveIndex, self.sliderAnimClasses.right)
                self.revealSlide(newIndex, self.sliderAnimClasses.right)
                self.currentActiveIndex = newIndex
                self.updateControls()
                self.updateAriaAttributes()

                // recall itself
                self.startAutoSlide(self.sliderAutoSpeed)
            }, speed, self)
        },

        stopAutoSlide: function () {
            clearTimeout(this.sliderTimeout)
        },

        preloadImages: function () {
            let timespan = 1
            let i = 0

            while (i <= this.slidesCount - 1) {
                const image = this.slides[i].querySelector('.lazy-slide')
                setTimeout(function () {
                    if (image !== undefined && image !== null) {
                        loadImage(image)
                    }
                }, timespan)
                timespan += 1500
                ++i
            }
        }
    }

    jsSlider.init()
}

jsSlider()

function jsSlider2 () {
    const jsSlider2 = {
        sliderClass: 'js-slider2',
        slideClass: 'js-slider2__slide',
        controlsClass: 'js-slider2__controls',
        controlClass: 'js-slider2__control',
        playControlClass: 'js-slider2__play',
        playIconClass: 'icon icon__play',
        pauseControlClass: 'js-slider2__pause',
        pauseIconClass: 'icon icon__pause',
        slider: null,
        sliderAnimTypeAttributeName: 'data-js-slider-animation-type',
        sliderAnimType: 'fade', // valid values are : 'fade', 'directional'
        sliderAnimClasses: { left: 'fade', right: 'fade' },
        slides: null,
        slidesCount: 0,
        sliderTimeout: null,
        revealTimeout: null,
        hideTimeout: null,
        hideTimeout2: null,
        rebindControlsTimeout: null,
        animTime: 1000, // must be >= to css transition time
        sliderAutoSpeed: 5000,
        currentActiveIndex: 0,

        init: function () {
            this.slider = document.querySelector('.' + this.sliderClass)

            if (!this.validSlider()) {
                return
            }

            this.slides = this.slider.querySelectorAll('.' + this.slideClass)
            this.slidesCount = this.slides.length

            if (this.slidesCount >= 2) {
                this.setAnimStyle()
                this.setSlides()
                this.preloadImages()
                this.setSlidesHeight()
                this.bindSliderListeners()
                this.createControls()
                this.bindResize()
                this.startAutoSlide(this.sliderAutoSpeed)
            }
        },

        validSlider: function () {
            if (this.slider == null || typeof this.slider === 'undefined') {
                return false
            } else {
                return true
            }
        },

        bindSliderListeners: function () {
            const self = this

            // When the focus enters the slider, suspend the animation
            this.slider.addEventListener('focusin', function () {
                self.stopAutoSlide()
            })
        },

        setSlides: function () {
            $(this.slides).attr('aria-hidden', true)
            this.slides[0].classList.add('active')
            this.slides[0].setAttribute('aria-hidden', false)
            this.currentActiveIndex = 0
        },

        setSlidesHeight: function () {
            // get highest slide and set this height to all slides

            let highest = 0
            let slideHeight = 0

            for (let i = 0; i < this.slidesCount; i++) {
                // reset to auto to get raw height value

                $(this.slides[i]).height('auto')
                slideHeight = $(this.slides[i]).height()
                highest = slideHeight < highest ? highest : slideHeight
            }
            $(this.slides).height(highest + 'px')
        },

        bindResize: function () {
            // must set slides height at resize

            window.addEventListener('resize', function () {
                jsSlider2.setSlidesHeight()
            })
        },

        setAnimStyle: function () {
            const sliderAnimValue = this.slider.getAttribute(this.sliderAnimTypeAttributeName)

            if (sliderAnimValue == null || sliderAnimValue === 'fade') {
                return
            }

            if (sliderAnimValue === 'directional') {
                this.sliderAnimType = 'directional'
                this.sliderAnimClasses.left = 'left'
                this.sliderAnimClasses.right = 'right'
            }
        },

        createControls: function () {
            // create elements
            const controlsContainer = document.createElement('fieldset')
            const playControl = document.createElement('button')
            const playIcon = document.createElement('span')
            const pauseControl = document.createElement('button')
            const pauseIcon = document.createElement('span')

            // fieldset container
            controlsContainer.setAttribute('class', this.controlsClass)
            controlsContainer.setAttribute('aria-controls', 'carousel')
            controlsContainer.setAttribute('aria-label', 'Contrôles du caroussel')

            // play button
            playControl.setAttribute('class', this.playControlClass)
            playControl.setAttribute('aria-label', 'Activer le défilement automatique du caroussel')
            playIcon.setAttribute('class', this.playIconClass)
            playIcon.setAttribute('aria-hidden', 'true')
            playControl.appendChild(playIcon)
            controlsContainer.appendChild(playControl)

            // pause button
            pauseControl.setAttribute('class', this.pauseControlClass)
            pauseControl.setAttribute('aria-label', 'Désactiver le défilement automatique du caroussel')
            pauseIcon.setAttribute('class', this.pauseIconClass)
            pauseIcon.setAttribute('aria-hidden', 'true')
            pauseControl.appendChild(pauseIcon)
            controlsContainer.appendChild(pauseControl)

            // direct slide access buttons
            for (let i = 0; i < this.slidesCount; i++) {
                const newControl = document.createElement('button')
                newControl.setAttribute('class', this.controlClass)
                newControl.setAttribute('data-index', i)
                newControl.setAttribute('aria-label', 'Diapositive ' + (i + 1) + ' de ' + this.slidesCount)
                controlsContainer.appendChild(newControl)
            }

            // append all controls to slider
            this.slider.appendChild(controlsContainer)

            this.bindPlayPause()
            this.bindControls()
            this.updateControls()
        },

        bindPlayPause: function () {
            const self = this

            // bind play control
            $('.' + this.playControlClass).on('click', function () {
                self.stopAutoSlide()
                self.startAutoSlide(500)
            })

            // bind pause control
            $('.' + this.pauseControlClass).on('click', function () {
                self.stopAutoSlide()
            })
        },

        bindControls: function () {
            const self = this

            // bind direct slide access controls
            $('.' + this.controlClass).on('click', function () {
                const newIndex = parseInt(this.getAttribute('data-index'))
                let direction = ''

                // do nothing if click on current index
                if (newIndex === self.currentActiveIndex) {
                    return
                }

                // stop autoslide
                self.stopAutoSlide()

                // unbind controls temporarily
                self.unbindControls()

                // determine direction
                direction = newIndex > self.currentActiveIndex ? self.sliderAnimClasses.right : self.sliderAnimClasses.left

                self.hideSlide(self.currentActiveIndex, direction)
                self.revealSlide(newIndex, direction)
                self.currentActiveIndex = newIndex
                self.updateControls()
                self.updateAriaAttributes()
                self.updateFocus()
            })
        },

        unbindControls: function () {
            // unbind controls when slider is in transition to prevent 2 animation from occuring at same time
            const self = this

            $('.' + this.controlClass).off('click')

            // rebind controls after transition is over
            this.rebindControlsTimeout = setTimeout(function () {
                self.bindControls()
            }, this.animTime)
        },

        updateControls: function () {
            // visually update controls style
            const controlClass = this.controlClass
            const index = this.currentActiveIndex
            const newActiveControl = this.slider.querySelector('.' + controlClass + '[data-index="' + index + '"]')
            $('.' + controlClass).removeClass('active')
            newActiveControl.classList.add('active')
        },

        updateAriaAttributes: function () {
            // update all slides aria-hidden attributes
            $(this.slides).attr('aria-hidden', true)
            this.slides[this.currentActiveIndex].setAttribute('aria-hidden', false)
        },

        updateFocus: function () {
            // set focus on slide content (this function is intended to be called after using a slider control)
            const target = this.slides[this.currentActiveIndex]
            target.setAttribute('tabindex', '-1')
            target.focus()
        },

        revealSlide: function (index, direction) {
            const self = this

            // prepare elem for animation
            this.slides[index].classList.add('fadein')
            this.slides[index].classList.add(direction)
            const image = this.slides[index].querySelector('.lazy-slide')
            if (image !== undefined && image !== null) {
                loadImage(image)
            }

            // quick delay to prevent display:block canceling animation
            self.revealTimeout = setTimeout(function () {
                // add class that launch animation
                self.slides[index].classList.add('active')

                // remove preparation classes
                self.slides[index].classList.remove('fadein')
                self.slides[index].classList.remove(direction)
            }, 45)
        },

        hideSlide: function (index, direction) {
            const self = this

            // must always add and remove 'active' classes at the same time
            this.hideTimeout = setTimeout(function () {
                // the classes that launch animation
                self.slides[index].classList.add('fadeout')
                self.slides[index].classList.add(direction)
                self.slides[index].classList.remove('active')
            }, 50)

            // remove when animation is over
            this.hideTimeout2 = setTimeout(function () {
                self.slides[index].classList.remove('fadeout')
                self.slides[index].classList.remove(direction)
            }, self.animTime)
        },

        startAutoSlide: function (speed) {
            const self = this
            this.sliderTimeout = setTimeout(function () {
                // unbind controls temporarily
                self.unbindControls()

                const newIndex = self.currentActiveIndex === self.slidesCount - 1 ? 0 : parseInt(self.currentActiveIndex) + 1
                self.hideSlide(self.currentActiveIndex, self.sliderAnimClasses.right)
                self.revealSlide(newIndex, self.sliderAnimClasses.right)
                self.currentActiveIndex = newIndex
                self.updateControls()
                self.updateAriaAttributes()

                // recall itself
                self.startAutoSlide(self.sliderAutoSpeed)
            }, speed, self)
        },

        stopAutoSlide: function () {
            clearTimeout(this.sliderTimeout)
        },

        preloadImages: function () {
            let timespan = 1
            let i = 0

            while (i <= this.slidesCount - 1) {
                const image = this.slides[i].querySelector('.lazy-slide')
                setTimeout(function () {
                    if (image !== undefined && image !== null) {
                        loadImage(image)
                    }
                }, timespan)
                timespan += 1500
                ++i
            }
        }
    }

    jsSlider2.init()
}

jsSlider2()